export default __webpack_public_path__ + "static/15-a7a377875cdbdff10b5f6cbe03f10d46.png";